import { FC } from 'react';
import {
    ADBRIDG_CLASS,
    AdvertProvider,
    AdvertSlotDfp,
    AD_UNIT_PAGE_TYPE,
    AD_UNIT_SECTION,
    AD_UNIT_SECTION_NEW,
} from '@zoopla/adverts/dfp';
import { advertContainerStyle } from './ExperianAdvert.styles.css';
import { SearchType } from '@zoopla/landing-pages/types';

const ExperianAdvert: FC<{ slug: string }> = ({ slug }) => {
    // variables to handle advert properties
    const activity =
        slug === SearchType.HOUSE_PRICES
            ? 'house_prices_search'
            : 'listing_search';

    let bridgePage: AD_UNIT_SECTION = AD_UNIT_SECTION.UNKNOWN;
    let bridgePageNew: AD_UNIT_SECTION_NEW = AD_UNIT_SECTION_NEW.UNKNOWN;
    switch (slug) {
        case SearchType.FOR_SALE:
            bridgePage = AD_UNIT_SECTION.FOR_SALE;
            bridgePageNew = AD_UNIT_SECTION_NEW.FOR_SALE;
            break;
        case SearchType.TO_RENT:
            bridgePage = AD_UNIT_SECTION.TO_RENT;
            bridgePageNew = AD_UNIT_SECTION_NEW.TO_RENT;
            break;
        case SearchType.HOUSE_PRICES:
            bridgePage = AD_UNIT_SECTION.HOUSE_PRICES;
            bridgePageNew = AD_UNIT_SECTION_NEW.HOUSE_PRICES;
            break;
        case SearchType.NEW_HOMES:
            bridgePage = AD_UNIT_SECTION.NEW_HOMES;
            bridgePageNew = AD_UNIT_SECTION_NEW.NEW_HOMES;
            break;
        default:
            bridgePage = AD_UNIT_SECTION.UNKNOWN;
            bridgePageNew = AD_UNIT_SECTION_NEW.UNKNOWN;
    }
    return (
        <div
            className={advertContainerStyle}
            title="Experian Advert - Check your free Experian Credit Score"
            data-testid="experian-ad"
        >
            <AdvertProvider
                value={{
                    adBridgPage: bridgePage,
                    adBridgPageNew: bridgePageNew,
                    pageType: AD_UNIT_PAGE_TYPE.CHANNEL_LANDING_PAGE,
                    targeting: {
                        activity,
                    },
                }}
            >
                <AdvertSlotDfp
                    adbridgClass={ADBRIDG_CLASS.ADB_FLUID}
                    adbridgDataClass={ADBRIDG_CLASS.ADB_TEXT_LINK}
                    hasMarginTop={false}
                />
            </AdvertProvider>
        </div>
    );
};

export default ExperianAdvert;
